export default {"src":"/_next/static/media/Grey-Wolf-animation.b6cc9cff.gif","height":1084,"width":1930};